import { IClassname } from '@/lib/shared/model/classname';

export const Kitchenware = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4727 20.4725H23.6674C23.8369 20.4725 23.9994 20.4051 24.1193 20.2853C24.2391 20.1655 24.3064 20.003 24.3064 19.8335C24.2208 9.86575 22.2017 1.30371 20.4727 1.30371V30.6958"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6936 1.30371V7.69329C7.6936 8.71007 8.09751 9.6852 8.81648 10.4042C9.53545 11.1231 10.5106 11.527 11.5274 11.527C12.5441 11.527 13.5193 11.1231 14.2382 10.4042C14.9572 9.6852 15.3611 8.71007 15.3611 7.69329V1.30371"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5286 1.30371V30.6958"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
